// extracted by mini-css-extract-plugin
export var anchor = "index-module--anchor--2OvvS";
export var outerContainer = "index-module--outer-container--192g2";
export var textFadeTransition = "index-module--text-fade-transition--1fd6a";